import { StyleSheet } from "@react-pdf/renderer";
import colors from "core/resources/theme/colors";

export interface PDFTagStyleProps {
  rounded?: number;
  color?: string;
  accentColor?: string;
  variant?: "solid" | "outline";
  fontSize?: number;
}

export const makePDFTagStyleSheet = (props: PDFTagStyleProps = {}) => {
  const {
    accentColor = "white",
    color = colors.black,
    rounded = 4,
    variant = "outline",
    fontSize = 7,
  } = props;

  return StyleSheet.create({
    tag: {
      borderRadius: rounded,
      color: variant === "solid" ? accentColor : color,
      backgroundColor: variant === "solid" ? color : "white",
      borderWidth: 1,
      borderColor: color,
      paddingVertical: 0,
      paddingHorizontal: 6,
      height: 2 * fontSize,
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: "center",
      fontSize,
    },
  });
};
